// Configuración EmailJS - Poné acá tus datos de dashboard.emailjs.com
export const emailjsConfig = {
  publicKey: 'XM2MiMZzKZuL3ZQpX',
  serviceId: 'service_5v8hmlv',
  templateId: 'template_tbhhatl'
}
